
<app-page-search *ngIf="isOpen" (close)="isOpen = false" [configs]="service.configs$ | async"></app-page-search>
